import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useEffect, useMemo, useRef } from 'react';
import { withOverlay } from '../../components/common/withOverlay';
import useOnClickOutside from '../common/effects/useOnClickOutside';
import { isDark } from '../common/utils';
import { List } from '../list/list';
import styles from './auto-suggest.module.scss';
const SuggestionsMenu = ({ onSelection, id, width, data, size, onClose, }) => {
    const style = useMemo(() => width
        ? {
            '--suggestions-width': `${width}px`,
        }
        : {}, [width]);
    const ref = useRef(null);
    useEffect(() => {
        if (data?.focus) {
            ref.current?.focus();
        }
        else {
            ref.current?.blur();
        }
    }, [data?.focus]);
    const { onRef } = useOnClickOutside(onClose);
    const isDarkMode = useMemo(() => isDark(), []);
    const suggestionsClass = useMemo(() => classNames(styles.suggestions_wrapper, {
        [styles.dark]: isDarkMode,
    }), []);
    return (_jsx("div", { className: suggestionsClass, style: style, ref: onRef, children: _jsx(List, { options: data?.items, onSelection: onSelection, showCheckIcon: false, itemHeight: 35, id: id, border: false, ref: ref, size: size }) }));
};
const SuggestionsMenuOverlay = withOverlay(SuggestionsMenu, {
    backdropColor: 'transparent',
    disableAnimation: true,
    placement: 'bottom',
});
export { SuggestionsMenuOverlay };
